import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MyApp } from './app.component';
import { SHARED_PROVIDERS, SHARED_COMPONENTS, SHARED_DIRECTIVES, InputLimiterDirective, AppContainerComponent } from './features/shared/shared';
import { CLM_COMPONENTS } from './features/companyLicenseManagement/companyLicenseManagement';
import { USER_COMPONENTS } from './features/userManagement/userManagement';
import { registerLocaleData } from '@angular/common';

import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe);

@NgModule({
  declarations: [
    SHARED_COMPONENTS,
    CLM_COMPONENTS,
    USER_COMPONENTS,
    InputLimiterDirective,
    MyApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(AppContainerComponent),
    HttpClientModule,
    BrowserAnimationsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    SHARED_COMPONENTS,
    CLM_COMPONENTS,
    USER_COMPONENTS,
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    SHARED_PROVIDERS,
    {provide: LOCALE_ID, useValue: 'de'},
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts